import { MAP_STRUCTURES_SHARING, LANDING, ORDERS_PROGRESS_SHARING, SIGNIN, SIGNUP } from "@farmact/model/src/constants/farmActAppRoutes";

export const routesWithoutMenu = [LANDING, SIGNIN, SIGNUP, ORDERS_PROGRESS_SHARING, MAP_STRUCTURES_SHARING];
